import { Button } from "@components/ui/Button"
import { Card, CardBody } from "@components/ui/Card"
import { GraduationCap, Plus } from "lucide-react"
import { memo } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

interface Props {
  onCtaClick?: () => void
}

export const HomeFirstRunCard = memo(function HomeFirstRunCard({ onCtaClick }: Props) {
  const { t } = useTranslation("home")
  return (
    <Card className="border-dashed">
      <CardBody className="flex flex-col items-center gap-3 px-6 py-10 text-center">
        <span className="bg-accent-soft text-accent-ink flex h-14 w-14 items-center justify-center rounded-full">
          <GraduationCap className="h-7 w-7" />
        </span>
        <div className="space-y-1">
          <h2 className="text-ink text-lg font-semibold">{t("first_run.title")}</h2>
          <p className="text-ink-subtle max-w-md text-sm">{t("first_run.message")}</p>
        </div>
        <Link to="/salones?creating=1" onClick={onCtaClick}>
          <Button leftIcon={<Plus className="h-4 w-4" />}>{t("first_run.cta")}</Button>
        </Link>
      </CardBody>
    </Card>
  )
})
